import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import _ from 'lodash';
import moment from 'moment';
import { Select, DatePicker, Switch } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValueLoadable } from 'recoil';
import {
  dashboardOptionAtom,
  dashboardSelectedStoreAtom,
  dashboardPayloadAtom
} from '../../../../atoms/Atoms';
import { businessesSelector } from '../../../../atoms/Selectors';
import { dateRangePresets } from '../../../utils/utils';

function Header() {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const [dashboardOption, setDashboardOption] = useRecoilState(dashboardOptionAtom);
  const [selectedStoreId, setSelectedStoreId] = useRecoilState(dashboardSelectedStoreAtom);
  const businesses = useRecoilValueLoadable(businessesSelector);
  const [dashboardPayload, setDashboardPayload] = useRecoilState(dashboardPayloadAtom);

  function isValidOptionForDatepicker() {
    return dashboardOption === 0 || dashboardOption === 6 || dashboardOption === 8 || dashboardOption === 9;
  }

  function renderRangePicker() {
    return (
      <>
        {isValidOptionForDatepicker() && (
          <div className="col-span-2 md:mt-2">
            <div className="flex space-x-2">
              {!dashboardPayload?.isLifetime && (
                <RangePicker
                  format="YYYY-MM-DD"
                  className="w-4/5 md:w-auto"
                  value={[
                    dayjs(dashboardPayload?.start),
                    dayjs(dashboardPayload?.end)
                  ]}
                  presets={dateRangePresets(t)}
                  onChange={(date, dateString) => {
                    setDashboardPayload({
                      ...dashboardPayload,
                      start: dateString[0],
                      end: dateString[1]
                    });
                  }}
                />
              )}
              <div>
                <span className="">{t('show_lifetime')}</span>
                <Switch
                  className="ml-1"
                  checked={dashboardPayload?.isLifetime}
                  onChange={(checked) => {
                    setDashboardPayload({
                      ...dashboardPayload,
                      isLifetime: checked
                    });
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  function renderOptionsSelect() {
    return (
      <Select
        className="w-full md:w-48"
        value={dashboardOption}
        onChange={(obj) => setDashboardOption(obj)}
       >
        <Option value={0}>{t('sales')}</Option>
        <Option value={9}>{t('statistics')}</Option>
        <Option value={6}>{t('customers')}</Option>
        <Option value={4}>{t('trends')}</Option>
        <Option value={7}>{t('prep_inventory')}</Option>
        <Option value={8}>{t('top_products')}</Option>
      </Select>
    );
  }

  function renderStoresSelect() {
    return (
      <Select
        className="w-full md:w-48"
        value={selectedStoreId}
        onChange={(obj) => setSelectedStoreId(obj)}
      >
        <Option value="">{t('all_stores')}</Option>
        {_.map(businesses?.contents?.data?.data?.results, (b) => (
          <Option key={b.id} value={b.id}>{b.name}</Option>
        ))}
      </Select>
    );
  }

  useEffect(() => {
    setDashboardPayload({
      start: moment().startOf('week').format('YYYY-MM-DD'),
      end: moment().endOf('week').format('YYYY-MM-DD'),
      isLifetime: false,
      load: false
    });
    setSelectedStoreId('');
  }, []);

  return (
    <div>
      <PageHeader
        className="md:mb-4 px-0"
        title={t('global_dashboard')}
        extra={
          <div className="hidden grid ml-8 md:ml-0 md:flex md:space-x-2 space-y-2">
            {renderRangePicker()}
            <div className="grid md:flex mx-auto space-y-2 md:space-y-0 md:space-x-2">
              {renderOptionsSelect()}
              {renderStoresSelect()}
            </div>
          </div>
        }
      />
      <div className="mb-4 grid grid-cols-2 w-full gap-2 md:hidden">
        {renderRangePicker()}
        <div className="col-span-1">{renderOptionsSelect()}</div>
        <div className="col-span-1">{renderStoresSelect()}</div>
      </div>
    </div>
  );
}

export default Header;
